export default __webpack_public_path__ + "static/dge_cover-big_1-005303dfcbf5102164a90088a169757f.webp";